<template lang="pug">
  div
    slot(v-bind:openModal="openModal" v-bind:closeModal="closeModal")
      button(@click.prevent="openModal" type="button") {{$t('Войти')}}
    modal(:name="loginModalName" :appentToBody="true" :adaptive="true"  height="auto" :clickToClose="false").login-modal
      .login-modal-inner
        .modal-header
          button.close(type='button' @click.prevent="closeModal" aria-label='Close' v-if="!isDisabled")
            span(aria-hidden='true') ×
          ul
            li.active
              h3.modal-title {{$t('Вход')}}
            template(v-if="!isDisabled")
              li
                h3.modal-title
                  a(href="/reg" title="Регистрация") {{$t('Регистрация')}}


        login-form(ref="loginForm" :disabled="isDisabled"
          @login-2fa-start="onLogin2FaStarted"
          body-slot-class="modal-body"
          @login-start="onLoginStarted"
          @login-2fa-fail="onLoginFail"
          @login-end="onLoginEnded"
          @login-fail="onLoginFail"
          @login-success="onLoginSuccess"
          @login-2fa-submit="onLoginStarted"
          @2fa-press-enter="onPasswordPressEnter"
          @password-press-enter="onPasswordPressEnter")
          template(v-slot:after="slotProps")
            template(v-if="!slotProps.googleCodeMode")
              .modal-footer
                .login-buttons-row
                  div
                  div
                    a.link(href="/remember" v-show="!isDisabled") {{$t('Восстановить пароль')}}
                  button.btn.btn-success(type="button" :disabled="isDisabled" @click.prevent="onClickSubmit")
                    template(v-if="isDisabled")
                      circle-loader(size="12px") {{$t('Входим...')}}
                    template(v-if="!isDisabled") {{$t('Войти')}}
            template(v-if="slotProps.googleCodeMode")
              .modal-footer
                .login-buttons-row
                  div
                  button.btn.btn-success-outline(type='button' :disabled="isDisabled" @click='onClickCancel') {{$t('Отмена')}}
                  button.btn.btn-success(type="button" :disabled="isDisabled" @click.prevent="onClickSubmit")
                    template(v-if="isDisabled")
                      circle-loader(size="12px") {{$t('Входим...')}}
                    template(v-if="!isDisabled") {{$t('Войти')}}
        //.modal-footer
          .login-buttons-row
            a.link(href="/remember" v-show="!isDisabled") {{$t('Восстановить пароль')}}
            button.btn.btn-success(type="button" :disabled="isDisabled" @click.prevent="onClickSubmit")
              template(v-if="isDisabled")
                circle-loader(size="12px") {{$t('Входим...')}}
              template(v-if="!isDisabled") {{$t('Войти')}}
          //

</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

import VModal from 'vue-js-modal';
import GuestFormGroup from '@/components/forms/guest/GuestFormGroup.vue';

import LoginForm from '@/views/pages/auth/login/LoginForm.vue';
import AuthModel from '@/core/auth/AuthModel';
import {RemoteRequestState} from '@/backoffice/components/pages/taxrules/taxrules';
import {AuthResults} from '@/core/auth/Auth';
import CircleLoader from '@/components/loaders/CircleLoader.vue';

Vue.use(VModal);

@Component({
  name: 'login-button',
  components: {CircleLoader, LoginForm, GuestFormGroup},
})
export default class LoginButton extends Vue {
  internalId = Math.random();

  submitStatus = new RemoteRequestState();

  @Prop({default: false})
  disabled!: boolean


  onPasswordPressEnter() {
    this.onClickSubmit();
  }

  disableWindow = false;

  get busyModel(): boolean {
    return this.submitStatus.isLoading;
  }


  onLogin2FaStarted(model: AuthModel) {
    this.disableWindow = false;
    this.submitStatus.loadEnd();
  }

  onLoginStarted(model: AuthModel) {
    this.disableWindow = true;
    this.submitStatus.loadStart();
  }

  onLoginEnded(model: AuthModel) {
    return null;
  }

  onLoginFail(model: AuthModel) {
    this.disableWindow = false;
    this.submitStatus.loadError();
  }

  onLoginSuccess(model: AuthModel, result: AuthResults) {
    let url = '';
    try {
      url = `${result!.getResponseData().returnUrl}` as string;
    } catch (err) {
      url = '/finance';
    }
    window.location.href = url;
  }

  get isDisabled(): boolean {
    return this.busyModel || this.disabled || this.disableWindow;
  }

  get loginModalName() {
    return `login-modal-${this.internalId}`;
  }

  openModal() {
    this.$modal.show(this.loginModalName);
  }

  closeModal() {
    this.$modal.hide(this.loginModalName);
  }

  onClickCancel() {
    (this.$refs.loginForm as any).cancel();
  }

  onClickSubmit() {
    (this.$refs.loginForm as any).submit();
  }
}
</script>

<style scoped lang="less">
@import "../../../../../src/less-mixins/mixins";

.login-modal {
  ::v-deep {

    .captcha-row {
      display: grid;
      grid-template-columns: 1fr max-content;
      grid-gap: 20px;
      //align-content: center;
      //align-items: center;
      .captcha-image {
        margin-top: 26px;
      }
    }

    .vm--modal {
      .border-radius(6px);
    }

    .modal-footer {
      padding: 25px;

      .login-buttons-row {
        display: grid;
        grid-gap: 15px;
        grid-template-columns: auto min-content min-content;
        align-items: center;
        a {
          margin-right: 25px;
          white-space: nowrap;
        }
      }
    }

    .modal-body {
      padding: 25px 25px 15px 25px;

      .form-group {
        margin-bottom: 25px;
      }
    }

    .modal-header {
      border-bottom: 1px solid #e5e5e5;
      padding: 25px 25px 0 25px;

      ul {
        display: inline-block;
        list-style-type: none;
        margin-bottom: 0;

        li {
          display: inline-block;
          margin-right: 30px;

          h3 {

            padding-bottom: 10px;
          }

          &.active, &:hover {
            color: #000;

            h3 {
              border-bottom: 2px solid #5c8f08;
            }
          }
        }
      }

      .close {
        padding: 0;
        cursor: pointer;
        background: transparent;
        border: 0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
      }

      .close {
        float: right;
        font-size: 21px;
        font-weight: 700;
        line-height: 1;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        filter: alpha(opacity=20);
        opacity: .2;
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "Вход": "Log in",
    "Входим...": "Logging in...",
    "Войти": "Log in",
    "Восстановить пароль": "Remember password",
    "Регистрация": "Registration",
    "Отмена": "Cancel"
  }
}
</i18n>
